export default "__VITE_ASSET__Bp0taj8k__"